import React from 'react';
import { useState, useEffect, useRef } from 'react';
import _, { cloneDeep } from 'lodash';
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Tooltip } from 'primereact/tooltip';
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import { generateGoalReport, downloadDocs, qualitativeGoalActionComplete, deleteFileQualitative } from '../../../../Services/opportunityService';
import RadioElement from '../../../../Components/UiComponents/RadioElement';
import CalendarElement from '../../../../Components/UiComponents/CalendarElement';
import DropdownElement from '../../../../Components/UiComponents/DropdownElement';
import { Chart } from 'primereact/chart';
import MultiSelectElement from '../../../../Components/UiComponents/MultiSelectElement';
import SingleSelectElement from '../../../../Components/UiComponents/SingleSelectElement';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import { InputIcon } from 'primereact/inputicon';
import { Dialog } from 'primereact/dialog';
import moment from 'moment';
import { useOpportunity } from "../../../../Providers/OpportunityContext";
import DataTable from '../../../../Components/UiComponents/DataTable';
import socket from '../../../../socket';
import { clearCompletedNotification } from '../../../../Services/notificationService';
import { useNavigate } from 'react-router-dom';
import ExcelUploader from './ExcelUploader';
import ExcelUploaderQualitative from './ExcelUploaderQualitative';


const Qualitative = (props) => {

	const [loading, setLoading] = useState(false);
	const [newModule, setNewModule] = useState({});
	const [opportunityData, setOpportunityData] = useState({});
	const [tooltipElem, setTooltipElem] = useState({});
	const [chartData, setChartData] = useState({});
	const [chartOptions, setChartOptions] = useState({});
	const [showDropdown, setShowDropdown] = useState(false);
	const [goalDetails, setGoalDetails] = useState([]);
	const [editGoalIden, setEditGoalIden] = useState(false);
	const [goalIdentificationModal, setGoalIdentificationModal] = useState(false);
	const [goalData, setGoalData] = useState({});
	const [selectedIndex, setSelectedIndex] = useState([]);
	const [goalTypeModel, setGoalTypeModel] = useState([]);
	const [tempGoalModel, setTempGoalModel] = useState([]);
	const [subPlanned, setSubPlanned] = useState([]);
	const [targetManagementCompletedModal, setTargetManagementCompletedModal] = useState(false);
	const [isUserActionOwnerSameTarget, setIsUserActionOwnerSameTarget] = useState(false);
	const [selectedOwner, setSelectedOwner] = useState([]);
	const [selectedStatus, setSelectedStatus] = useState([]);
	const [upload, setUpload] = useState(false);
	const [uploadTarget, setUploadTarget] = useState(false);
	const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
	const navigate = useNavigate()
	const toastRef = useRef();
	const enduser = localStorage.getItem("enduser");
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
			navigate("/login")
			localStorage.clear()
		}
	}
	const [view, setView] = useState(false);
	const [completedState, setCompletedState] = useState(false);
	const [parentIndex, setParentIndex] = useState(0);
	const [subIndex, setSubIndex] = useState(0);
	const [goalAttachment, setGoalAttachment] = useState([]);
	const [tempDelete, setTempDelete] = useState([]);

	var statusFilter = [
		{ _id: 1, label: "Completed", value: true },
		{ _id: 2, label: "Incomplete", value: false },
	];

	useEffect(() => {
		if (props.opportunityData && props.goalType) {
			setOpportunityData(props.opportunityData)
			loadGoalDataList(props.opportunityData, props.goalType)
		}
	}, [props.opportunityData])

	useEffect(() => {
		var updatedOpportunityData = opportunityData;
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			logframe_target: updatedOpportunityData.logframe_target,
			summary: updatedOpportunityData.summary,
			qualitative_goal_identification: goalDetails,
		}));
	}, [opportunityData, goalDetails, goalData]);


	useEffect(() => {
		if (completedState) {
			setGoalDetails(prevGoalDetails => {
				const updatedData = [...prevGoalDetails];
				updatedData[parentIndex].goal_details[subIndex].status = false;
				return updatedData;
			});
			setCompletedState(false)
		}
	}, [completedState])

	const loadGoalDataList = (opportunityDetails, goalType, preLoad = false) => {
		var goalDetails = opportunityDetails?.qualitative_goal_identification?.slice(0);
		var goalTypemodel = [];
		var subPlannedArr = [];
		var tempGoalmodel = [];
		if (goalDetails != undefined) {
			for (var i = 0; i < goalDetails.length; i++) {
				var goal_head = goalType.filter(
					(item) => item.id === goalDetails[i].goal
				);
				if (!_.isEmpty(goal_head)) {
					goalDetails[i].goal_typeLabel = goal_head[0].label;
					goalTypemodel.push({
						label: goal_head[0].label,
						id: goal_head[0].id,
					});

					tempGoalmodel.push({
						label: goal_head[0].label,
						id: goal_head[0].id,
					});

					for (var j = 0; j < goalDetails[i].goal_details.length; j++) {
						if (!_.isEmpty(goalDetails[i].goal_details[j].target)) {
							var tmpFactor1 = goal_head[0].label;
							const referenceItem = props.reference_data.find(
								(item) => item.display_name === tmpFactor1
							);
							const tmpOpts1 = referenceItem
								? referenceItem.option_choice.filter((option) => option.status === "active")
								: [];

							const goalTarget = tmpOpts1.filter(
								(item) => item._id === goalDetails[i].goal_details[j].target
							);

							if (!_.isEmpty(goalTarget)) {
								goalDetails[i].goal_details[j].target_label = goalTarget[0].label;
								var tmpFactor = goal_head[0].label;

								const referenceItem = props.reference_data.find(
									(item) => item.display_name === tmpFactor
								);
								const tmpOpts = referenceItem
									? referenceItem.option_choice.filter((option) => option.status === "active")
									: [];

								goalDetails[i].targetOptions = tmpOpts;
								const referenceItem1 = props.reference_data.find(
									(item) => item.display_name === goalTarget[0].label
								);
								var tmpOptsIndicatorFinal = referenceItem1
									? referenceItem1.option_choice.filter((option) => option.status === "active")
									: [];

								goalDetails[i].goal_details[j].indicatorOptions = tmpOptsIndicatorFinal;
								var tmpOptsSubIndicator = tmpOptsIndicatorFinal.filter(
									(item) => item._id === goalDetails[i].goal_details[j].indicator
								);

								var SubIndicatorLabel = []
								if (!_.isEmpty(tmpOptsSubIndicator)) {
									goalDetails[i].goal_details[j].indicator_label = tmpOptsSubIndicator[0].label;

									const referenceItem2 = props.reference_data.find(
										(item) => item.display_name === tmpOptsSubIndicator[0].label
									);

									var tmpOptsSubIndicatorFinal = referenceItem2
										? referenceItem2.option_choice.filter((option) => option.status === "active")
										: [];

									SubIndicatorLabel = tmpOptsSubIndicatorFinal.filter(
										(item) => item._id === goalDetails[i].goal_details[j].sub_indicator
									);

								}
								if (!_.isEmpty(SubIndicatorLabel)) {
									goalDetails[i].goal_details[j].sub_indicator_label = SubIndicatorLabel[0].label;
									goalDetails[i].goal_details[j].subIndicatorOptions = tmpOptsSubIndicatorFinal;
								}
								if (goalDetails[i].goal_details[j].sub_indicator && goalDetails[i].goal_details[j].planned != undefined && goalDetails[i].goal_details[j].achieved != undefined && SubIndicatorLabel.length > 0) {
									subPlannedArr.push({
										sub_indicator_label: SubIndicatorLabel[0].label,
										// planned: goalDetails[i].goal_details[j].planned,
										// achieved: goalDetails[i].goal_details[j].achieved,
										sub_planned: goalDetails[i].goal_details[j].sub_planned,
										percentage: parseFloat(((goalDetails[i].goal_details[j].achieved / goalDetails[i].goal_details[j].planned) * 100).toFixed(2)),
									});
								}
							}
						}
					}
				}
			}
		}
		setSubPlanned(subPlannedArr)
		if (!preLoad) {
			setGoalDetails(goalDetails)
			setGoalTypeModel(goalTypemodel)
			setTempGoalModel(tempGoalmodel)
		}
		performancePercentage(subPlannedArr);
	};

	const performancePercentage = (subPlan) => {
		var dataSubArray = [];
		var dataPrev = [];
		var data = [];
		var grouped = _.groupBy(subPlan, function (car) {
			return car.sub_indicator_label;
		});
		let sums = Object.values(grouped).map((arr) =>
			arr.reduce(
				(sums, { sub_indicator_label, planned, achieved, percentage }) => ({
					sub_indicator_label,
					planned: sums.planned + +planned,
					achieved: sums.achieved + +achieved,
					percentage: percentage,
				}),
				{ planned: 0, achieved: 0 }
			)
		);
		var finalArr = sums;
		finalArr.map((e) => {
			dataSubArray.push({
				percentage: e.percentage,
				sub_indicator_label: e.sub_indicator_label,
				planned: e.planned,
				achieved: e.achieved,
			});
			dataPrev.push([e.sub_indicator_label, 100, e.planned]);
			data.push([
				e.sub_indicator_label,
				parseFloat(((e.achieved / e.planned) * 100).toFixed(2)),
				e.achieved,
			]);
		});

		var cateArray = [];
		dataSubArray.forEach((element, key) => {
			var keys = key + 1;
			cateArray.push("SI" + keys);
		});

		function getData(data) {
			return data.map(function (country) {
				return parseFloat((country[1] / 100) * 100).toFixed(2);
			});
		}

		function getDataPlanned(data) {
			return data.map(function (country) {
				return parseFloat((country[2] / 100) * 100).toFixed(2);
			});
		}


		const chartData = {
			labels: cateArray,
			title: {
				text: "Performance Chart",
				align: "center",
			},
			datasets: [
				{
					label: 'Planned',
					backgroundColor: '#A6ACAF',
					data: getDataPlanned(dataPrev),
					barPercentage: 0.5,
					categoryPercentage: 0.5,
				},
				{
					label: 'Achieved',
					backgroundColor: '#42A5F5',
					data: getData(data),
					barPercentage: 0.5,
					categoryPercentage: 0.5,
				}
			]
		};
		const options = {
			responsive: true,
			maintainAspectRatio: false,
			plugins: {
				legend: {
					display: false,
				},
				tooltip: {
					callbacks: {
						title: (tooltipItems) => {
							return tooltipItems[0].label;
						},
						label: (tooltipItem) => {
							const datasetLabel = tooltipItem.dataset.label || '';
							const value = tooltipItem.raw;
							// Retrieve the original value (country[2]) using the data index
							// const originalValue = data[tooltipItem.dataIndex][2];
							// if (datasetLabel === 'Achieved' && originalValue > 100) {
							// 	return `${datasetLabel}: ${originalValue}%`; // Show original value for "Achieved"
							// }
							return `${datasetLabel}: ${value}%`;
						}
					}
				}
			},
			scales: {
				x: {
					title: {
						display: true,
						text: 'Categories'
					},
				},
				y: {
					min: 0,
					max: 100,
					ticks: {
						stepSize: 25,
						callback: (value) => `${value}%`
					},
					title: {
						display: true,
						text: 'Planned & Achieved (%)'
					}
				}
			}
		};
		setChartData(chartData);
		setChartOptions(options);
	}

	useEffect(() => {
		var deepCopy = _.cloneDeep(globalOpportunityData);
		if (deepCopy && deepCopy.qualitative_goal_identification?.length > 0)
			loadGoalDataList(deepCopy, props.goalType, true)
	}, [view, goalDetails, globalOpportunityData])



	const parseDateString = (dateStr) => {
		if (dateStr != '' && dateStr != undefined) {
			const [day, month, year] = dateStr?.split('-').map(Number);
			return new Date(year, month - 1, day);
		}
	};

	const formatDate = (input) => {
		const date = (input instanceof Date) ? input : new Date(input);
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	};

	// To save opportunity data
	const handleInputChange = (field1, field2, value) => {
		if (field1 && field2 && value)
			setOpportunityData((prevOpportunityDetails) => ({
				...prevOpportunityDetails,
				[field1]: {
					...prevOpportunityDetails[field1],
					[field2]: value?.target?.value
				},
			}));
	};

	const handleCheckChange = (field1, field2, value) => {
		const updatedOpportunityDetails = { ...opportunityData };
		updatedOpportunityDetails[field1] = {
			...updatedOpportunityDetails[field1],
			[field2]: {
				...updatedOpportunityDetails[field1]?.[field2],
				radio: value,
			},
		};
		setOpportunityData(updatedOpportunityDetails);
	};

	const handleCalenderInputChange = (field1, field2, value) => {
		const updatedOpportunityDetails = { ...opportunityData };
		updatedOpportunityDetails[field1] = {
			...updatedOpportunityDetails[field1],
			[field2]: {
				...updatedOpportunityDetails[field1]?.[field2],
				text: value,
			},
		};
		setOpportunityData(updatedOpportunityDetails);
	};

	const onChangeManager = (value, field1, field2) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...prevOpportunityDetails[field1],
				[field2]: value?._id
			},
		}));
	}

	const goalOnSelection = (e) => {
		var addedItem = [];
		var deletedItem = [];
		var updatedGoalDetails = [...goalDetails];

		if (e.value.length > tempGoalModel.length) {
			addedItem = e.value.filter(
				({ id: id1 }) =>
					!tempGoalModel.some(({ id: id2 }) => id2 === id1)
			);

			const goal_details = [{
				comments: "",
				response_to_question: "",
				indicatorOptions: [],
				subIndicatorOptions: [],
				status: false,
				completedStatus: "",
				sub_indicator_label: "",
			}];

			var tmpGoalIndex = _.findIndex(tempGoalModel, { id: addedItem[0].id });
			if (tmpGoalIndex === -1) {
				tempGoalModel.push(addedItem[0]);
			}

			const index = updatedGoalDetails.push({
				goal_typeLabel: addedItem[0].label,
				targetOptions: [],
				goal: addedItem[0].id,
				goal_details: goal_details,
			});

			var tmpFactor = addedItem[0].label;
			const referenceItem = props.reference_data.find(
				(item) => item.display_name === tmpFactor
			);
			var tmpOpts = referenceItem
				? referenceItem.option_choice.filter((option) => option.status === "active")
				: [];
			updatedGoalDetails[index - 1].targetOptions = tmpOpts;

		} else if (e.value.length < tempGoalModel.length) {
			deletedItem = tempGoalModel.filter(
				({ id: id1 }) =>
					!e.value.some(({ id: id2 }) => id2 === id1)
			);
			var planIndex = _.findIndex(updatedGoalDetails, { goal: deletedItem[0].id });
			var index = _.findIndex(tempGoalModel, { label: deletedItem[0].label });
			tempGoalModel.splice(index, 1);
			updatedGoalDetails.splice(planIndex, 1);
		}
		setTempGoalModel([...tempGoalModel]);
		setGoalDetails(updatedGoalDetails);
	};

	const uploadFile = () => {
		setUpload(true)
	}

	const uploadGoalFile = () => {
		setUploadTarget(true)
	}

	const removeImage = (index) => {
		const updatedAttachment = [...goalAttachment];

		if (updatedAttachment[index]?.name !== undefined) {
			const updatedTempDelete = [...tempDelete, updatedAttachment[index].name];
			setTempDelete(updatedTempDelete);
		}

		updatedAttachment.splice(index, 1);
		setGoalAttachment(updatedAttachment);
	};

	// const deleteFiles = async () => {
	// 	var res = await deleteFile(tempDelete)
	// 	if (res && res.data.success == true) {
	// 		setTempDelete([]);
	// 	}
	// };
	const deleteFiles = async (goalDetail) => {
		try {
			setLoading(true);

			// Call API to delete files
			const res = await deleteFileQualitative(tempDelete, globalOpportunityData._id, goalDetail);

			// Check the response and handle success
			if (res && res.data && res.data.success === true) {
				toastRef.current.showToast({
					type: "success",
					message: "Files deleted successfully.",
				});
				const updatedGoalDetail = goalDetails.map((goal) => {
					// For each goal, we iterate through the goal_details array
					goal.goal_details = goal.goal_details.map((detail) => {
						// If there are attachments, filter them
						if (detail.attachment) {
							// Filter out the attachments whose name is in tempDelete
							detail.attachment = detail.attachment.filter(att => !tempDelete.includes(att.name));
						}
						return detail; // Return the updated goal detail
					});

					return goal; // Return the updated goal with updated goal_details
				});

				// Now update the goalDetail state
				setGoalDetails(updatedGoalDetail);
				// setTempDelete([]); // Clear the tempDelete array	
			} else {
				// Handle cases where deletion was not successful
				toastRef.current.showToast({
					type: "error",
					message: res.data?.message || "Failed to delete files. Please try again.",
				});
			}
		} catch (error) {
			// Handle any errors during the API request
			toastRef.current.showToast({
				type: "error",
				message: "An error occurred while deleting files. Please try again.",
			});
		} finally {

			setLoading(false);
		}
	};


	const removeTemplate = (rowData, index) => {
		return <InputIcon
			className="pi pi-trash ml-0 pointer"
			onClick={() => removeImage(index.rowIndex)}
		/>
	}

	const sizeTemplate = (rowData) => {
		return (rowData.size / 1024 / 1024).toPrecision(2)
	}

	const openImage = (url) => {
		window.location.href = url;
	}

	const downloadTemplate = (rowData, index) => {
		return <InputIcon
			className="pi pi-download ml-0 pointer"
			onClick={() => openImage(rowData.url, index.rowIndex)}
		/>
	}

	const columns = [
		{ field: "fileName", header: "Name", headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "size", header: "Size (MB)", body: sizeTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "type", header: "Type", headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "url", header: "Download", body: downloadTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "remove", header: "Remove", body: removeTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const columns1 = [
		{ field: "fileName", header: "Name", headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "size", header: "Size (MB)", body: sizeTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "type", header: "Type", headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "url", header: "Download", body: downloadTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const indiTargetData = (data) => {
		setGoalAttachment((prevState) => ([
			...prevState,
			data
		]))
	}

	const targetData = (data) => {
		setLoading(true)
		var goalData = data;
		if (goalData && Array.isArray(goalData)) {
			goalData.forEach(item => {
				var goalType = props.goalType.find(gt => gt.label === item.goal);
				if (!goalType) {
					console.error(`Goal type not found for: ${item.goal}`);
					return;
				}
				var existingGoalType = goalTypeModel.find(gt => gt.id === goalType.id);
				if (!existingGoalType) {
					goalTypeModel.push(goalType);
					tempGoalModel.push(goalType);
				}

				const referenceItem = props.reference_data.find(
					(i) => i.display_name === item.goal
				);

				var targetOptions = referenceItem
					? referenceItem.option_choice.filter((option) => option.status === "active")
					: [];

				const referenceItem1 = props.reference_data.find(
					(i) => i.display_name === item.goal_details.target
				);

				var indicatorOptions = referenceItem1
					? referenceItem1.option_choice.filter((option) => option.status === "active")
					: [];

				const referenceItem2 = props.reference_data.find(
					(i) => i.display_name === item.goal_details.indicator
				);

				var subIndicatorOptions = referenceItem2
					? referenceItem2.option_choice.filter((option) => option.status === "active")
					: [];



				var existingGoalIndex = goalDetails.findIndex(goal => goal.goal === goalType.id);
				if (existingGoalIndex > -1) {
					var existingGoal = goalDetails[existingGoalIndex];

					existingGoal.goal_details.push({
						target: targetOptions.find(opt => opt.label === item.goal_details.target)?._id,
						target_label: item.goal_details.target,
						indicator: indicatorOptions.find(opt => opt.label === item.goal_details.indicator)?._id,
						indicator_label: item.goal_details.indicator,
						sub_indicator: subIndicatorOptions.find(opt => opt.label === item.goal_details.sub_indicator)?._id,
						sub_indicator_label: item.goal_details.sub_indicator,
						response_to_question: item.goal_details.response_to_question,
						// planned: item.goal_details.planned,
						link: item.goal_details.link,
						score: props.score.find(opt => opt.label === item.goal_details.score)?._id,
						// unitOfMeasurement: props.unitOfMeasurement.find(opt => opt.label === item.goal_details.unitOfMeasurement)?._id,
						attribution: props.attribution.find(opt => opt.label === item.goal_details.attribution)?._id,
						goal_month: moment(item.goal_details.goal_month_date, "DD/MM/YYYY").format("DD-MM-YYYY"),
						owner: props.internBidUserFilter.find(opt => opt.label === item.goal_details.owner)?._id,
						targetOptions: targetOptions,
						indicatorOptions: indicatorOptions,
						subIndicatorOptions: subIndicatorOptions,

					});
				} else {
					goalDetails.push({
						goal_typeLabel: goalType.label,
						goal: goalType.id,
						goal_details: [{
							target: targetOptions.find(opt => opt.label === item.goal_details.target)?._id,
							target_label: item.goal_details.target,
							indicator: indicatorOptions.find(opt => opt.label === item.goal_details.indicator)?._id,
							indicator_label: item.goal_details.indicator,
							sub_indicator: subIndicatorOptions.find(opt => opt.label === item.goal_details.sub_indicator)?._id,
							response_to_question: item.goal_details.response_to_question,
							// planned: item.goal_details.planned,
							link: item.goal_details.link,
							score: props.score.find(opt => opt.label === item.goal_details.score)?._id,
							// unitOfMeasurement: props.unitOfMeasurement.find(opt => opt.label === item.goal_details.unitOfMeasurement)?._id,
							attribution: props.attribution.find(opt => opt.label === item.goal_details.attribution)?._id,
							goal_month: moment(item.goal_details.goal_month_date, "DD/MM/YYYY").format("DD-MM-YYYY"),
							owner: props.internBidUserFilter.find(opt => opt.label === item.goal_details.owner)?._id,
							targetOptions: targetOptions,
							indicatorOptions: indicatorOptions,
							subIndicatorOptions: subIndicatorOptions
						}],
						targetOptions: targetOptions
					});
				}
			});
		}
		toastRef.current.showToast({
			type: 'success',
			message: 'File Uploaded Successfully'
		});
		setLoading(false)
		setView(!view);
		var updatedOpportunityData = { ...opportunityData }
		// updatedOpportunityData.goal_identification = goalDetails
		updatedOpportunityData.qualitative_goal_identification = goalDetails
		loadGoalDataList(updatedOpportunityData, props.goalType)
	}

	const onCloseUploadPopup = () => {
		setUpload(false);
	};

	const onCloseUploadTargetPopup = () => {
		setUploadTarget(false)
	}

	const resetButton = () => {
		var owner = []
		var status = []
		setSelectedOwner(owner)
		setSelectedStatus()
		filterSubData(owner, status)
		setShowDropdown(false)
	}

	const toggleDropdown = () => {
		setShowDropdown(!showDropdown)
	}

	const filterSubData = (value, statusValue) => {
		value.length > 0 ? setSelectedOwner(value) : setSelectedOwner([])
		statusValue.length > 0 ? setSelectedStatus(statusValue) : setSelectedStatus([])

		setGoalDetails(prevGoalDetails => {
			const updatedData = [...prevGoalDetails];

			for (var rskType = 0; rskType < updatedData.length; rskType++) {
				for (var record = 0; record < updatedData[rskType].goal_details.length; record++) {
					var isAOMatching = false,
						isStatMatching = false;
					for (var ao = 0; ao < value.length; ao++) {
						if (updatedData[rskType].goal_details[record].owner == value[ao]._id) {
							isAOMatching = true;
							break;
						}
					}
					for (var stat = 0; stat < statusValue.length; stat++) {
						if (updatedData[rskType].goal_details[record].status == statusValue[stat]) {
							isStatMatching = true;
							break;
						}
					}
					if (value.length == 0 && statusValue.length == 0)
						updatedData[rskType].goal_details[record].showRecord = true;
					else if (value.length > 0 && statusValue.length > 0)
						updatedData[rskType].goal_details[record].showRecord = isAOMatching && isStatMatching;
					else if (value.length > 0 || statusValue.length > 0)
						updatedData[rskType].goal_details[record].showRecord = isAOMatching || isStatMatching;
				}
				if (value.length == 0 && statusValue.length == 0)
					updatedData[rskType].showSection = true;
				else {
					var records = _.find(updatedData[rskType].goal_details, {
						showRecord: true,
					});
					if (!_.isEmpty(records)) {
						updatedData[rskType].showSection = true;
					} else {
						updatedData[rskType].showSection = false;
					}
				}
			}
			return updatedData;
		});
	};

	const addNewGoal = () => {
		if (selectedIndex.length > 0) {
			const updatedGoalDetails = goalDetails.map((goal, ind) => {
				const selected = selectedIndex.includes(goal);
				if (selected) {
					const value_checked = goal.goal_details.filter(
						(item) => item.checked === true
					);

					if (goal.checked) {
						return {
							...goal,
							goal_details: [
								...goal.goal_details,
								{ comments: "" }
							]
						};
					} else if (value_checked.length > 0) {
						const clonedValue = _.cloneDeep(value_checked[0]);
						clonedValue.checked = false;

						return {
							...goal,
							goal_details: [
								...goal.goal_details,
								clonedValue
							]
						};
					}
				}

				return goal;
			});
			setGoalDetails(updatedGoalDetails);
		}
		setSelectedIndex([])
	};

	const removeGoal = () => {
		selectedIndex.length > 0 && selectedIndex.forEach(
			function (value, index) {
				var ind = goalDetails.indexOf(value);
				var ngIndex = goalTypeModel.map(function (item) { return item.id; }).indexOf(value.goal);
				var tmpInd = tempGoalModel.map(function (item) { return item.id; }).indexOf(value.goal);
				if (value.checked) {
					goalDetails.splice(goalDetails.indexOf(value), 1);
					goalTypeModel.splice(ngIndex, 1);
					tempGoalModel.splice(tmpInd, 1);

					var subPlannedArr = [];
					goalDetails.map((ele) => {
						ele.goal_details.map((lo) => {
							subPlannedArr.push({
								sub_indicator: lo.sub_indicator,
								sub_indicator_label: lo.sub_indicator_label,
								// planned: lo.planned,
								link: lo.achieved,
								sub_planned: true,
								percentage: parseFloat(lo.planned == 0 ? 0 : ((lo.achieved / lo.planned) * 100).toFixed(2)),
							});
						});
					});
					setSubPlanned(subPlannedArr)
					performancePercentage(subPlannedArr);
				} else {
					const foundSec = value.goal_details.find(
						(item) => item.checked === true
					);
					goalDetails[ind].goal_details.splice(goalDetails[ind].goal_details.indexOf(foundSec), 1);
					if (goalDetails[ind].goal_details.length == 0) {
						goalDetails.splice(ind, 1);
						goalTypeModel.splice(ngIndex, 1);
						tempGoalModel.splice(tmpInd, 1);
					}
					var subPlannedArr = [];
					goalDetails.map((ele) => {
						ele.goal_details.map((lo) => {
							subPlannedArr.push({
								sub_indicator: lo.sub_indicator,
								sub_indicator_label: lo.sub_indicator_label,
								// planned: lo.planned,
								// achieved: lo.achieved,
								sub_planned: true,
								percentage: parseFloat(lo.planned == 0 ? 0 : ((lo.achieved / lo.planned) * 100).toFixed(2)),
							});
							lo.checked = false;
						});
					});
					setSubPlanned(subPlannedArr)
					performancePercentage(subPlannedArr);
				}
			}
		);
		setGoalDetails(goalDetails);
		setSelectedIndex([])
	}

	const openGoalIdentification = (isEdit, index, section) => {
		var goalData = {};
		var tmpCategory = "";
		var status = "";
		if (isEdit) {
			setEditGoalIden(true);
		} else {
			setEditGoalIden(false);
		}
		setGoalIdentificationModal(true)
		var ind = goalDetails.indexOf(section);
		if (!_.isUndefined(section.goal_details[index].target)) {
			var tmpFactor1 = section.goal_typeLabel;

			const referenceItem = props.reference_data.find(
				(item) => item.display_name === tmpFactor1
			);

			const tmpOpts1 = referenceItem
				? referenceItem.option_choice.filter((option) => option.status === "active")
				: [];

			const goalTarget = tmpOpts1.filter(
				(item) => item._id === section.goal_details[index].target
			);

			tmpCategory = goalTarget.length > 0 ? goalTarget[0].label : '';
		}
		if (section.goal_details[index].status) {
			status = "Completed";
		} else {
			status = "Not Completed";
		}

		if (!_.isEmpty(section.goal_details[index].attachment)) {
			section.goal_details[index].attachment.forEach((e, index) => {
				if (e.name == undefined) {
					section.goal_details[index].attachment.splice(index, 1);
				}
			});
			if (tempDelete.length > 0) {

				var goalAttachment = section.goal_details[index].attachment.filter(att => !tempDelete.includes(att.name));
				setGoalAttachment(goalAttachment)
				setTempDelete([])
			} else {
				setGoalAttachment(section.goal_details[index].attachment)
			}
		} else {
			setGoalAttachment([])
		}

		goalData = {
			typeIndex: ind,
			catIndex: index,
			goal_typeLabel: section.goal_typeLabel,
			target: tmpCategory,
			comments: section.goal_details[index].comments,
			response_to_question: section.goal_details[index].response_to_question,
			status: status,
			section: section
		};
		setGoalData(goalData)
	}

	const cancelGoalCategory = () => {
		setGoalAttachment([{}]);
		setTempDelete([]);
		setGoalIdentificationModal(false)
	}

	const saveGoalCategory = () => {
		var typeIndex = goalData.typeIndex;
		var catIndex = goalData.catIndex;
		goalDetails[typeIndex].goal_details[catIndex].comments = goalData.comments;
		goalDetails[typeIndex].goal_details[catIndex].response_to_question = goalData.response_to_question;
		goalAttachment.forEach((e, index) => {
			if (e.name == undefined) {
				goalAttachment.splice(index, 1);
			}
		});

		if (tempDelete.length > 0) {
			deleteFiles(goalData);
		}
		if (goalAttachment.length > 0) {
			goalDetails[typeIndex].goal_details[catIndex].attachment = goalAttachment;
			toastRef.current.showToast({
				type: 'success',
				message: "Document Updated Successfully"
			});
		}
		setGoalDetails(goalDetails)
		setGoalIdentificationModal(false)
	}

	const renderFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						editGoalIden ?
							<>
								<ButtonElement label="Cancel" className="cancel-new-button" onClick={() => cancelGoalCategory()} />
								<ButtonElement type="submit" label="Save" className="save-button" onClick={() => saveGoalCategory()} />
							</>
							:
							<ButtonElement type="submit" label="Cancel" className="cancel-new-button" onClick={() => cancelGoalCategory()} />
					}
				</div>
			</div>
		);
	};

	const modalTargetCompleted = async () => {
		try {
			setLoading(true);

			const parentIndex = goalData.parentIndex;
			const index = goalData.index;

			// Deep clone the goal data to avoid mutation
			const tmpGoalData = _.cloneDeep(goalDetails[parentIndex].goal_details[index]);

			// Call API to mark the goal action as completed
			const result = await qualitativeGoalActionComplete(
				opportunityData._id,
				props.customerId,
				parentIndex,
				index,
				tmpGoalData
			);

			if (result && result.data) {
				if (result.data.success) {
					// Clear the completed notification
					const clearCompNotify = await clearCompletedNotification(tmpGoalData._id);

					if (clearCompNotify && clearCompNotify.data && clearCompNotify.data.status) {
						// Emit push notifications via socket
						socket.emit('pushNotifications', props.customerId);
					}

					setTargetManagementCompletedModal(false);

					// Update the goal status
					goalDetails[parentIndex].goal_details[index].status = true;

					// Show success notification
					toastRef.current.showToast({
						type: 'success',
						message: result.data.message,
					});
				} else {
					// Show error message if API indicates failure
					toastRef.current.showToast({
						type: 'error',
						message: result.data.message || 'Failed to complete the goal action.',
					});
				}
			} else {
				// Handle case where result structure is unexpected
				toastRef.current.showToast({
					type: 'error',
					message: 'Unexpected response from the server. Please try again.',
				});
			}
		} catch (error) {
			// Handle any errors that occur during the process
			toastRef.current.showToast({
				type: 'error',
				message: 'Failed to complete the target. Please try again or contact Admin.',
			});
		} finally {
			setLoading(false);
		}
	};


	const closeTargetCompleted = () => {
		const parentIndex = goalData.parentIndex;
		const index = goalData.index;

		const updatedGoalDetails = [...goalDetails];

		const newGoalDetails = updatedGoalDetails[parentIndex].goal_details.map((detail, i) =>
			i === index ? { ...detail, status: false } : detail
		);

		updatedGoalDetails[index] = {
			...updatedGoalDetails[parentIndex],
			goal_details: newGoalDetails,
		};

		setGoalDetails(updatedGoalDetails);
		setTargetManagementCompletedModal(false);
	};

	const renderTargetFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						isUserActionOwnerSameTarget ?
							<>
								<ButtonElement label="No" className="cancel-new-button" onClick={() => closeTargetCompleted()} />
								<ButtonElement type="submit" label="Yes" className="save-button" onClick={() => modalTargetCompleted()} />
							</>
							:
							<ButtonElement type="submit" label="Close" className="save-button" onClick={() => closeTargetCompleted()} />
					}
				</div>
			</div>
		);
	};

	const handleTarget = (catIndex, entity, selectedRow, e) => {
		const updatedGoalDetails = [...goalDetails];
		const typeIndex = updatedGoalDetails.indexOf(entity);
		if (!_.isEmpty(e?.value?._id) && e?.target?.name === "target") {
			const risk = updatedGoalDetails[typeIndex].targetOptions.find(
				(item) => item._id === e.value._id
			);

			if (!_.isEmpty(risk)) {
				updatedGoalDetails[typeIndex].goal_details[catIndex].target_label = risk.label;
				updatedGoalDetails[typeIndex].goal_details[catIndex].target = risk._id;
				const tmpFactor = risk.label;
				const referenceItem = props.reference_data.find(
					(item) => item.display_name === tmpFactor
				);

				const tmpOpts = referenceItem
					? referenceItem.option_choice.filter((option) => option.status === "active")
					: [];
				updatedGoalDetails[typeIndex].goal_details[catIndex].indicatorOptions = tmpOpts;
			}
		} else {
			updatedGoalDetails[typeIndex].goal_details[catIndex].target_label = "";
		}
		setGoalDetails(updatedGoalDetails);
	};

	const handleGoalDetails = (catIndex, entity, selectedRow, e) => {
		const updatedGoalDetails = [...goalDetails];
		const typeIndex = updatedGoalDetails.indexOf(entity);
		const label = e.target.name;
		const value = e.value._id;
		const goalId = entity._id ? entity._id : (entity.goal ? entity.goal : null)
		if (label && value && goalId) {
			// Update the goal details based on goal ID and selected target
			const updatedGoals = updatedGoalDetails.map((goal) => {
				if (goal._id === goalId || goal.goal === goalId) {
					goal.goal_details = goal.goal_details.map((detail, index) => {
						if (index === catIndex) {
							// Update specific fields like target_label, unit_of_measurement, or attribution_value
							return {
								...detail,
								[label]: value,
								// Add additional fields to update here as needed
								// ...(label === "target" && {
								// 	target_label: value,
								// 	// Update other fields related to target_label if needed
								// }),
								// ...(label === "unit_of_measurement" && {
								// 	unit_of_measurement: value,
								// }),
								// ...(label === "attribution_value" && {
								// 	attribution_value: value,
								// }),
							};
						}
						return detail;
					});
				}
				return goal;
			});
			// Assuming you store the updated goals in a state variable
			setGoalDetails(updatedGoals);

		} else {
			// updatedGoalDetails[typeIndex].goal_details[catIndex].target_label = "";
		}
		// setGoalDetails(updatedGoalDetails);
	};

	const handleIndicator = (catIndex, entity, selectedRow, e) => {
		const updatedGoalDetails = [...goalDetails];
		var typeIndex = updatedGoalDetails.indexOf(entity);
		if (!_.isEmpty(e?.value?._id) && e?.target?.name === "indicator") {
			var risk = updatedGoalDetails[typeIndex].goal_details[catIndex].indicatorOptions.find(
				(item) => item._id === e.value._id
			);

			if (!_.isEmpty(risk)) {
				updatedGoalDetails[typeIndex].goal_details[catIndex].indicator_label = risk.label;
				updatedGoalDetails[typeIndex].goal_details[catIndex].indicator = risk._id;
				var tmpFactor = risk.label;
				const referenceItem = props.reference_data.find(
					(item) => item.display_name === tmpFactor
				);

				const tmpOpts = referenceItem
					? referenceItem.option_choice.filter((option) => option.status === "active")
					: [];

				updatedGoalDetails[typeIndex].goal_details[catIndex].subIndicatorOptions = tmpOpts;
			}
		} else {
			updatedGoalDetails[typeIndex].goal_details[catIndex].indicator_label = "";
		}
		setGoalDetails(updatedGoalDetails);
	}

	const handleSubIndicator = (catIndex, entity, selectedRow, e) => {
		const updatedGoalDetails = [...goalDetails];

		var typeIndex = updatedGoalDetails.indexOf(entity);
		updatedGoalDetails[typeIndex].goal_details[catIndex].planned = 0;
		updatedGoalDetails[typeIndex].goal_details[catIndex].achieved = 0;
		if (!_.isEmpty(e?.value?._id) && e.target.name === "sub_indicator") {
			var goal = updatedGoalDetails[typeIndex].goal_details[catIndex].subIndicatorOptions.find(
				(item) => item._id === e.value._id
			);

			if (!_.isEmpty(goal)) {
				updatedGoalDetails[typeIndex].goal_details[catIndex].sub_indicator_label = goal.label;
				updatedGoalDetails[typeIndex].goal_details[catIndex].sub_indicator = goal._id;
			}
		} else {
			updatedGoalDetails[typeIndex].goal_details[catIndex].sub_indicator_label = "";
		}

		var subPlannedArr = [];
		updatedGoalDetails.map((ele) => {
			ele.goal_details.map((lo) => {
				subPlannedArr.push({
					sub_indicator: lo.sub_indicator,
					sub_indicator_label: lo.sub_indicator_label,
					// planned: lo.planned,
					// achieved: lo.achieved,
					sub_planned: true,
					percentage: parseFloat(lo.planned == 0 ? 0 : ((lo.achieved / lo.planned) * 100).toFixed(2)),
				});
			});
		});
		setSubPlanned(subPlannedArr)
		setGoalDetails(updatedGoalDetails)
		performancePercentage(subPlannedArr);
	}

	const handleDate = (e, index1, ind, field1) => {
		setGoalDetails(prevState =>
			prevState.map((goalDetail, index) =>
				index === index1
					? {
						...goalDetail,
						goal_details: goalDetail.goal_details.map((item, itemIndex) =>
							itemIndex === ind
								? { ...item, [field1]: moment(e.value).format("DD-MM-YYYY") }
								: item
						)
					}
					: goalDetail
			)
		);
	};

	const handleUser = (e, index1, ind, field1) => {
		setGoalDetails(prevState =>
			prevState.map((goalDetail, index) =>
				index === index1
					? {
						...goalDetail,
						goal_details: goalDetail.goal_details.map((item, itemIndex) =>
							itemIndex === ind
								? { ...item, [field1]: e.value._id }
								: item
						)
					}
					: goalDetail
			)
		);
	};

	const targetCompleted = (parentIndex, index, rDetails, rCategory, e) => {
		setGoalDetails(prevGoalDetails => {
			const updatedData = [...prevGoalDetails];
			updatedData[parentIndex].goal_details[index].status = e.checked;
			return updatedData;
		});
		setParentIndex(parentIndex)
		setSubIndex(index)

		if (e.checked == true) {
			if (goalDetails[parentIndex].goal_details[index]._id != undefined) {
				var goalData = {};
				var tmpTarget = goalDetails[parentIndex].goal_details[index].target;
				var isCompleted = goalDetails[parentIndex].goal_details[index].status;
				var tmpFactor1 = rDetails.goal_typeLabel;

				const referenceItem = props.reference_data.find(
					(item) => item.display_name === tmpFactor1
				);

				const tmpOpts1 = referenceItem
					? referenceItem.option_choice.filter((option) => option.status === "active")
					: [];

				var goalTarget = tmpOpts1.find(
					(item) => item._id === tmpTarget
				);

				var tmpCategory = goalTarget.label;
				goalData = {
					parentIndex: parentIndex,
					index: index,
					goal_typeLabel: rDetails.goal_typeLabel,
					target: tmpCategory,
					action_taken: rDetails.goal_details[index].action_taken,
					comments: rDetails.goal_details[index].comments,
					status: isCompleted,
				};
				if (goalDetails[parentIndex].goal_details[index].owner == tmpData.userid) {
					setIsUserActionOwnerSameTarget(true);
					setTargetManagementCompletedModal(true)
				} else {
					setIsUserActionOwnerSameTarget(false);
					setTargetManagementCompletedModal(true)
				}
				setGoalData(goalData)
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Please save the task"
				});
				setCompletedState(true)
			}
		}
	}

	const handleInputPlan = (e, index1, ind, field1) => {
		var subPlannedArr = [];
		const updatedGoalDetails = goalDetails.map((ele) => {
			ele.goal_details.map((lo) => {
				subPlannedArr.push({
					sub_indicator: lo.sub_indicator,
					sub_indicator_label: lo.sub_indicator_label,
					response_to_question: lo.response_to_question,
					link: lo.link,
					score: lo.score,
					sub_planned: true,
				});
			});

			return ele;
		});


		const newGoalDetails = updatedGoalDetails.map((goalDetail, index) =>
			index === index1
				? {
					...goalDetail,
					goal_details: goalDetail.goal_details.map((item, itemIndex) =>
						itemIndex === ind
							? { ...item, [field1]: e.target.value }
							: item
					)
				}
				: goalDetail
		);

		setGoalDetails(newGoalDetails);
		setSubPlanned(subPlannedArr);
		performancePercentage(subPlannedArr);
	}

	const singleSelectGoal = (e, position, entities) => {

		const updatedEntities = entities.map((subscription, index) => {
			if (position !== index) {
				return {
					...subscription,
					checked: false,
					goal_details: subscription.goal_details.map(detail => ({
						...detail,
						checked: false
					}))
				};
			} else {
				return {
					...subscription,
					checked: e.checked,
					goal_details: subscription.goal_details.map(detail => ({
						...detail,
						checked: false
					}))
				};
			}
		});
		setGoalDetails(updatedEntities);
		const selectedSection = updatedEntities[position];
		setSelectedIndex([selectedSection]);
	}

	const singleSelectTarget = (e, ind, position, entities) => {
		const updatedEntities = entities.map((subscription, index) => {
			const updatedTarget = subscription.goal_details.map((q, targetIndex) => {
				if (index === ind && targetIndex === position) {
					return {
						...q,
						checked: e.checked
					};
				} else {
					return {
						...q,
						checked: false
					};
				}
			});

			return {
				...subscription,
				checked: false,
				goal_details: updatedTarget
			};
		});
		setGoalDetails(updatedEntities);
		const selectedSection = updatedEntities[ind];
		setSelectedIndex([selectedSection]);
	}



	const dropdownRef = useRef(null);
	const handleOutsideClick = (event) => {
		if (showDropdown) {
			const target = event.target;
			const dropdownButton = document.querySelector('.clear-filter-button');
			const dropdownContent = document.querySelector('.s-field');
			const multiSelectInput = document.querySelector('.p-multiselect-filter');

			// Check if the clicked element is not in the dropdown, the button, or any MultiSelect/single select items
			if (
				!dropdownContent.contains(target) &&
				target !== dropdownButton &&
				target !== multiSelectInput &&
				!target.closest('.p-multiselect-item') && // MultiSelect items
				!target.closest('.p-dropdown-item') // Single select dropdown items
			) {
				setShowDropdown(false);
			}
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleOutsideClick);

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, [showDropdown]);

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			{
				<form className='grid-display-target'>
					{
						// Object.entries(newModule)?.map(([key, value]) => (
						<div className='mt-10'>
							<Accordion activeIndex={0}>
								{
									<AccordionTab header={props.fieldData.pipelineQualitativeHeader} disabled>
										{
											// key == 'obj1' &&
											<div className='new-field'>
												<div className='mt-20'>
													{
														_.find(props.fieldData.oppQualitativeTable, { table_name: "Goal" })?.status &&
														<div className="form-group row align-items-center mb-0 mt-10">
															{
																_.find(props.fieldData.pipelineLogFrameFields, { field_name: 'Goal' })?.field_status &&
																<>
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{_.find(props.fieldData.pipelineLogFrameFields, { field_name: 'Goal' })?.display_name}:</label>
																	</div>
																	{/* <div className="col-md-1 pl-0">
																			{
																				props.customerTooltipRisks?.risk_identification.risk_type.status.status == true &&
																				<div>
																					<Tooltip target=".custom-target-icon" />

																					<i className="custom-target-icon pi pi-info-circle tooltip-font"
																						data-pr-tooltip={props.customerTooltipRisks?.risk_identification.risk_type.status.text}
																						data-pr-position="right">
																					</i>
																				</div>
																			}
																		</div> */}
																	<div className='col pr-0'>
																		<MultiSelectElement
																			value={goalTypeModel}
																			optionLabel="label"
																			options={props.goalType}
																			placeholder="-- Please select --"
																			maxSelectedLabels={1}
																			onChangeValue={(e) => goalOnSelection(e)}
																			className="w-full"
																			showSelectAll={false}
																		/>
																	</div>
																</>
															}
															{
																<div className="form-group row align-items-center mb-0 mt-10">
																	<div className="col pr-0 d-flex justify-end delete-icon">
																		<ButtonElement type="button" className="edit-option-button" icon="pi pi-upload" onClick={uploadFile} />
																		<ButtonElement type="button" icon="pi pi-filter-slash" className="edit-option-button font-text ml-20" onClick={resetButton} />
																		<div className='p-relative ml-20' ref={dropdownRef}>
																			<ButtonElement type="button" className="edit-option-button" icon="pi pi-filter" onClick={toggleDropdown} />
																			{showDropdown && (
																				<>
																					<div className='s-field'>
																						<div className='new-field w-100'>
																							<div className="form-group row align-items-center mb-0 mt-0">
																								<div className="col-md-5 pl-0">
																									<label className="form-label text-left">
																										Action Owner:
																									</label>
																								</div>
																								<div className="col pr-0">
																									<MultiSelectElement
																										value={selectedOwner}
																										optionLabel="label"
																										options={props.userFilterReports}
																										placeholder="-- Please select --"
																										maxSelectedLabels={1}
																										onChangeValue={(e) => filterSubData(e.value, selectedStatus)}
																										className="w-full"
																									/>
																								</div>
																							</div>
																							<div className="form-group row align-items-center mb-0 mt-0">
																								<div className="col-md-5 pl-0">
																									<label className="form-label text-left">
																										Status:
																									</label>
																								</div>
																								<div className="col pr-0">
																									<MultiSelectElement
																										value={selectedStatus}
																										optionLabel="label"
																										options={statusFilter}
																										placeholder="-- Please select --"
																										maxSelectedLabels={1}
																										onChangeValue={(e) => filterSubData(selectedOwner, e.value)}
																										className="w-full"
																									/>
																								</div>
																							</div>
																						</div>
																					</div>
																				</>
																			)}
																		</div>
																		<ButtonElement type="button" className="edit-option-button ml-20" icon="pi pi-trash" onClick={removeGoal} />
																		<ButtonElement type="button" className="edit-option-button ml-20" icon="pi pi-plus" onClick={() => addNewGoal()} />
																	</div>
																</div>
															}
														</div>
													}
													{
														_.find(props.fieldData.oppQualitativeTable, { table_name: 'Goal' })?.status &&
														<div className="group-table-data risks-tab">
															<table className="group-datatable">
																<thead className="group-table-header">
																	<tr>
																		<th className="checkbox-header"></th>
																		<th className="width-7">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Target' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Indicator' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Sub-Indicator' })?.display_name}</th>
																		<th className="width-14">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Response to Question' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Link/Attachment' })?.display_name}</th>
																		<th className="width-7">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Score' })?.display_name}</th>
																		<th className="width-10">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Comments' })?.display_name}</th>
																		<th className="width-9">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Month' })?.display_name}</th>
																		<th className="width-9">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Owner' })?.display_name}</th>
																		<th className="width-7">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Status' })?.display_name}</th>
																		<th className="width-7">{_.find(props.fieldData.oppQualitativeHeaders, { header_name: 'Action' })?.display_name}</th>
																	</tr>
																</thead>
																<tbody className="group-table-row stakeplan">
																	{
																		goalDetails?.map((subscription, index) => {
																			if (subscription?.showSection != false) {
																				return (
																					<React.Fragment>
																						<tr>
																							<td className="group-header">
																								<CheckboxElement
																									id={`check-${index}`}
																									name={`check-${index}`}
																									checked={subscription.checked}
																									onChangeCheck={(e) => singleSelectGoal(e, index, goalDetails)}
																									className="mr-2"
																								/>
																							</td>
																							<td className="group-header" colSpan={12}>
																								<label className='form-label text-left font-bold'>{subscription.goal_typeLabel}</label>
																							</td>
																						</tr>
																						{
																							subscription.goal_details?.map((sub, ind) => (

																								sub.showRecord != false &&
																								<tr>
																									<td>

																										<CheckboxElement
																											id={`sub-${ind}`}
																											name={`sub-${ind}`}
																											checked={sub.checked}
																											onChangeCheck={(e) => singleSelectTarget(e, index, ind, goalDetails)}
																											className="mr-2"
																										/>
																									</td>
																									<td className='width-7'>
																										<SingleSelectElement
																											id='target'
																											name="target"
																											options={(subscription?.targetOptions != undefined && subscription?.targetOptions.length > 0) ? subscription?.targetOptions : []}
																											optionLabel="label"
																											value={subscription?.targetOptions?.find((item) => item._id === sub.target)}
																											onChangeValue={(e) => handleTarget(ind, subscription, sub, e)}
																											placeholder="-- Please select --"
																											maxSelectedLabels={1}
																											className={(props.errors.includes('Target') && sub.target == undefined) ? 'error-tab w-150' : 'w-150'}
																										/>
																									</td>
																									<td className='width-10'>
																										<SingleSelectElement
																											id='indicator'
																											name="indicator"
																											options={(subscription?.goal_details[ind]?.indicatorOptions != undefined && subscription?.goal_details[ind]?.indicatorOptions.length > 0) ? subscription?.goal_details[ind]?.indicatorOptions : []}
																											optionLabel="label"
																											value={subscription?.goal_details[ind]?.indicatorOptions?.find((item) => item._id === sub.indicator)}
																											onChangeValue={(e) => handleIndicator(ind, subscription, sub, e)}
																											placeholder="-- Please select --"
																											maxSelectedLabels={1}
																											className="w-150"
																										/>
																									</td>
																									<td className='width-10'>
																										<SingleSelectElement
																											id='sub_indicator'
																											name="sub_indicator"
																											options={(subscription?.goal_details[ind]?.subIndicatorOptions != undefined && subscription?.goal_details[ind]?.subIndicatorOptions.length > 0) ? subscription?.goal_details[ind]?.subIndicatorOptions : []}
																											optionLabel="label"
																											value={subscription?.goal_details[ind]?.subIndicatorOptions?.find((item) => item._id === sub.sub_indicator)}
																											onChangeValue={(e) => handleSubIndicator(ind, subscription, sub, e)}
																											placeholder="-- Please select --"
																											maxSelectedLabels={1}
																											className="w-150"
																										/>
																									</td>
																									<td className='width-14'>
																										<label className="className='form-label text-left'" >
																											{sub.response_to_question && sub.response_to_question.slice(0, 25)}
																										</label>
																										{sub.response_to_question && sub.response_to_question.length > 25 && <span className='form-label text-left'>...</span>}
																									</td>
																									<td className='width-7'>
																										<InputTextElementElement
																											id="link"
																											name="link"
																											value={sub.link}
																											type="text"
																											// pattern="https?://.*" 
																											onChange={(e) => handleInputPlan(e, index, ind, 'link')}
																											className="w-full"
																										/>
																									</td>
																									<td className='width-7'>
																										<SingleSelectElement
																											id='sub_UnitOfMeasurement'
																											name="score"
																											options={(props.score != undefined && props.score.length > 0) ? props.score : []}
																											optionLabel="label"
																											value={props.score.find((item) => item._id === sub.score)}
																											onChangeValue={(e) => handleGoalDetails(ind, subscription, sub, e)}
																											placeholder="-- Please select --"
																											maxSelectedLabels={1}
																											className="w-150"
																										/>
																									</td>
																									<td className='width-10'>
																										<label className="className='form-label text-left'" >
																											{sub.comments && sub.comments.slice(0, 25)}
																										</label>
																										{sub.comments && sub.comments.length > 25 && <span className='form-label text-left'>...</span>}
																									</td>
																									<td className='width-9 target-cal'>
																										<CalendarElement
																											id="goal_month"
																											placeholder="Choose a date"
																											value={parseDateString(sub.goal_month)}
																											onChange={(e) => handleDate(e, index, ind, 'goal_month')}
																											readOnlyInput
																											className="w-150"
																										/>
																									</td>
																									<td className='width-9'>
																										<SingleSelectElement
																											id='target_owner'
																											name="target_owner"
																											options={(props.internBidUserFilter != undefined && props.internBidUserFilter.length > 0) ? props.internBidUserFilter : []}
																											optionLabel="label"
																											value={props.internBidUserFilter.find((item) => item._id === sub.owner)}
																											onChangeValue={(e) => handleUser(e, index, ind, 'owner')}
																											placeholder="-- Please select --"
																											maxSelectedLabels={1}
																											className="w-150"
																										/>
																									</td>
																									<td className='width-7'>
																										<CheckboxElement
																											id={`status-${ind}`}
																											name={`status-${ind}`}
																											value={sub.status}
																											checked={sub.status}
																											onChangeCheck={(e) => targetCompleted(index, ind, subscription, sub, e)}
																											className="mr-2"
																										/>
																									</td>
																									<td className='d-flex width-10'>
																										<InputIcon
																											className="pi pi-eye ml-0"
																											onClick={() => openGoalIdentification(false, ind, subscription)}
																										/>
																										<InputIcon
																											className="pi pi-pencil ml-10"
																											onClick={() => openGoalIdentification(true, ind, subscription)}
																										/>
																									</td>
																								</tr>
																							))}
																					</React.Fragment>
																				);
																			}
																		})
																	}
																</tbody>
															</table>
														</div>
													}
												</div>
											</div>
										}
									</AccordionTab>
								}
							</Accordion>
						</div>
						// )
						// )
					}
				</form>
			}
			<Dialog
				header={'Goal Identification : ' + goalData.goal_typeLabel}
				visible={goalIdentificationModal}
				position="right"
				onHide={() => cancelGoalCategory()}
				draggable={false}
				resizable={false}
				footer={renderFooter()}
				className="table-dialog width-32"
			>
				<div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Goal Target
							</label>
						</div>
						<div className="col pr-0">
							<label className="form-label text-left">{goalData.target}</label>
						</div>

					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Response To Question
							</label>
						</div>
						<div className="col pr-0">
							{
								editGoalIden ?
									<TextareaElement
										placeholder="Text"
										name="response_to_question"
										className="w-full"
										value={goalData.response_to_question}
										onChange={e => setGoalData((prevState) => ({
											...prevState,
											response_to_question: e.target.value
										}))}
										rows={3}
										required
									/> :
									<label className="form-label text-left">
										{goalData.response_to_question}
									</label>
							}
						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Goal Comments
							</label>
						</div>
						<div className="col pr-0">
							{
								editGoalIden ?
									<TextareaElement
										placeholder="Text"
										name="winplan_category"
										className="w-full"
										value={goalData.comments}
										onChange={e => setGoalData((prevState) => ({
											...prevState,
											comments: e.target.value
										}))}
										rows={3}
										required
									/> :
									<label className="form-label text-left">
										{goalData.comments}
									</label>
							}

						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Attachment(s)
							</label>
						</div>
						<div className="col pr-0">
							{
								editGoalIden ?
									<ButtonElement type="button" className="save-button ml-0" icon="pi pi-upload" onClick={uploadGoalFile} /> :
									""
							}

						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col pr-0 pl-0">
							<DataTable
								value={goalAttachment ? goalAttachment : []}
								columns={editGoalIden ? columns : columns1}
								dataKey="_id"
								isNewField={true}
							/>
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				header={"Target Management : " + goalData.goal_typeLabel + ' - ' + goalData.target}
				visible={targetManagementCompletedModal}
				position="right"
				onHide={() => closeTargetCompleted()}
				draggable={false}
				resizable={false}
				footer={renderTargetFooter()}
				className="table-dialog width-32"
			>
				<div>
					{
						isUserActionOwnerSameTarget ? <div className="confirmation-content">
							<span className="table-description">
								Do you want to complete this action?
							</span>
						</div> :
							<div className="confirmation-content">
								<span className="table-description">
									This action belongs to another user. Your are not authorised to complete this action.
								</span>
							</div>

					}
				</div>
			</Dialog>
			<Dialog
				header={"Upload File"}
				visible={upload}
				position="top"
				onHide={onCloseUploadPopup}
				className='width-50vw'
				draggable={false}
			>
				<ExcelUploader
					onCloseUploadPopup={onCloseUploadPopup}
					targetUpload={true}
					customerId={props.customerId}
					targetData={targetData}
				/>
			</Dialog>
			<Dialog
				header={"Upload File"}
				visible={uploadTarget}
				position="top"
				onHide={onCloseUploadTargetPopup}
				className='width-50vw'
				draggable={false}
			>
				<ExcelUploaderQualitative
					onCloseUploadPopup={onCloseUploadTargetPopup}
					customerId={props.customerId}
					indiTargetData={indiTargetData}
				/>
			</Dialog>
		</div>
	)
};

export default Qualitative;
